module.exports = __webpack_public_path__ + "img/accordian.eb886bd2.svg";